import React, {useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children?: React.ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    onClick?: () => void;
}

export const ShowMoreButton: React.FunctionComponent<IProps> = (props) => {
    const {preventShowLess, dataGtmClick, showMoreText, showLessText} = props;
    const [showContent, setShowContent] = useState<boolean>(false);
    const className = classNames(props.className);
    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    return (
        <>
            <div css={showContent ? show : hide}>{props.children}</div>

            <ShowMoreButtonBase
                showContent={showContent}
                className={className}
                css={showContent && preventShowLess && hide}
                variant="highlight_primary"
                onClick={() => setShowContent((prevState) => !prevState)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </ShowMoreButtonBase>
        </>
    );
};

interface IThemeProps {
    children: React.ReactNode;
    showContent: boolean;
}

const ShowMoreButtonBase = styled(Button)<IThemeProps>`
    overflow-anchor: ${(props) => (props.showContent ? "none" : "auto")};
`;

const show = css`
    display: block;
`;

const hide = css`
    display: none;
`;
import React, {useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import classNames from "classnames";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children?: React.ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    onClick?: () => void;
}

export const ShowMoreButton: React.FunctionComponent<IProps> = (props) => {
    const {preventShowLess, dataGtmClick, showMoreText, showLessText} = props;
    const [showContent, setShowContent] = useState<boolean>(false);
    const className = classNames(props.className);
    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    return (
        <>
            <div css={showContent ? show : hide}>{props.children}</div>

            <ShowMoreButtonBase
                showContent={showContent}
                className={className}
                css={showContent && preventShowLess && hide}
                variant="highlight_primary"
                onClick={() => setShowContent((prevState) => !prevState)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </ShowMoreButtonBase>
        </>
    );
};

interface IThemeProps {
    children: React.ReactNode;
    showContent: boolean;
}

const ShowMoreButtonBase = styled(Button)<IThemeProps>`
    overflow-anchor: ${(props) => (props.showContent ? "none" : "auto")};
`;

const show = css`
    display: block;
`;

const hide = css`
    display: none;
`;
